export default __webpack_public_path__ + "static/media/ELECTIVES_WOODWORKING.08cf8a4f.svg";